// extracted by mini-css-extract-plugin
export default {"section":"Organization_section__fnaKA","tabs":"Organization_tabs__co8Jd","tab":"Organization_tab__pWA2w","tabActive":"Organization_tabActive__70V20","btn":"Organization_btn__7APYq"};